import { toggleOptional } from './actions';
export const mapDispatchToProps = (dispatch, props) => {
    return {
        onSwitchChange: props.isOptional
            ? (e) => {
                dispatch(toggleOptional(e.target.checked, props.componentIdent));
            }
            : undefined,
    };
};
//# sourceMappingURL=container.js.map